import React from "react";

function WebTypeCustomDetailsStep({ handleChange, formData }) {
  return (
    <>
      <div className="row pb-5 pb-sm-5 pb-md-5 pb-lg-5 pb-xl-5">
        <div className="pt-3 mt-3">
          <h2 className="h6 pb-1 mb-3 color_grey">
            Great! Please Select Your Custom Software Needs.
          </h2>
        </div>

        <div className="col-lg-12">
          <div className="row row-cols-1 row-cols-sm-1 g-3 g-sm-4 pb-3 pb-sm-4 mb-xl-2">
            {/* Sector or Industry */}
            <div className="col">
              <label className="form-label">
                <span className="req__area">*</span> Sector or Industry
              </label>
              <select
                className="form-select form-select-lg choices__input"
                name="custom-software-sector"
                onChange={handleChange}
                value={formData["custom-software-sector"] || ""}
                style={{ maxWidth: "300px" }}
              >
                <option value="">Select...</option>
                <option value="Education / Training">
                  Education / Training
                </option>
                <option value="Real Estate">Real Estate</option>
                <option value="eCommerce / Export">eCommerce / Export</option>
                <option value="Fintech / Banking / Finance">
                  Fintech / Banking / Finance
                </option>
                <option value="Communication / Telecommunication">
                  Communication / Telecommunication
                </option>
                <option value="Logistics / Transportation">
                  Logistics / Transportation
                </option>
                <option value="Medical / Health">Medical / Health</option>
                <option value="Automotive">Automotive</option>
                <option value="Startup">Startup</option>
                <option value="Other">Other</option>
              </select>
            </div>
          </div>

          {/* Extra Options */}
          <div className="row">
            <div className="col-lg-12">
              <label className="form-label">Extra Options</label>
            </div>
            <div className="col-lg-12">
              <div className="row row-cols-1 row-cols-md-1 gy-3 gx-4">
                {[
                  { id: "crm-erp", label: "CRM / ERP" },
                  { id: "message-chat", label: "Messaging / Chat" },
                  { id: "booking", label: "Reservation / Booking" },
                  { id: "listing", label: "Company / Place / Service Listing" },
                  {
                    id: "image-video-process",
                    label: "Video / Audio Processing",
                  },
                  {
                    id: "ai-integration",
                    label: "Artificial Intelligence Integration",
                  },
                  { id: "real-time", label: "Live / Real-Time Streaming" },
                  { id: "chatbots", label: "Smart Chatbots" },
                  {
                    id: "cybersecurity",
                    label: "Data Protection or Cybersecurity",
                  },
                  { id: "map-location", label: "Map / Location-Based" },
                  { id: "kms", label: "KMS – Knowledge Management System" },
                ].map((option) => (
                  <div className="col" key={option.id}>
                    <div className="form-check mb-0">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id={option.id}
                        name="extra-options"
                        onChange={handleChange}
                        checked={
                          formData["extra-options"]?.includes(option.label) ||
                          false
                        }
                        value={option.label}
                      />
                      <label htmlFor={option.id} className="form-check-label">
                        {option.label}
                      </label>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default WebTypeCustomDetailsStep;
